/**
 * Bugs et idées remontés depuis le jeu (GDD §27).
 *
 * Volontairement ouvert aux parties non sécurisées : celui qui rencontre un bug
 * de première heure est précisément celui qui n'a pas encore de pseudonyme, et
 * c'est de lui qu'on a le plus besoin.
 */
export interface Retour {
  id: number
  pseudo: string | null
  type: "bug" | "idee"
  texte: string
  le: number
  etat: "ouvert" | "vu" | "fait" | "refuse"
  reponse: string | null
}

const lire = async (r: Response) => {
  const d = await r.json().catch(() => ({})) as Record<string, unknown>
  if (!r.ok) throw new Error(String(d.erreur ?? `Erreur ${r.status}`))
  return d
}

/** Les retours, et le droit d'y répondre. */
export interface Boite { retours: Retour[]; admin: boolean }

export async function retours(id: string): Promise<Boite> {
  const d = await lire(await fetch(`/api/retours?id=${encodeURIComponent(id)}`))
  return { retours: (d.retours ?? []) as Retour[], admin: Boolean(d.admin) }
}

/**
 * Répondre à un retour et changer son état.
 *
 * Le serveur revérifie le droit : ce que le client sait de son statut ne sert
 * qu'à afficher les commandes.
 */
export async function repondre(
  id: string, retour: number, etat: Retour["etat"], reponse: string,
): Promise<void> {
  await lire(await fetch("/api/retours", {
    method: "PATCH",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ id, retour, etat, reponse }),
  }))
}

export async function envoyerRetour(id: string, type: "bug" | "idee", texte: string): Promise<Retour> {
  const d = await lire(await fetch("/api/retours", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ id, type, texte }),
  }))
  return d as unknown as Retour
}
